function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
//Material imports
import Settings from "@mui/icons-material/Settings";
//Limitless imports
import HeaderIconButton from "../../buttons/header-icon-button/HeaderIconButton";
class SettingsHeaderItem extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      disableTooltip: false
    });
    _defineProperty(this, "onButtonClick", event => {
      this.setState({
        disableTooltp: true
      });
      this.props.handleSettingsDrawer(event);
    });
  }
  render() {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(HeaderIconButton, {
      buttonId: "settingsHeaderMenuButton",
      onButtonClick: this.onButtonClick,
      tooltip: "Change your settings",
      ariaLabel: "Settings",
      icon: /*#__PURE__*/React.createElement(Settings, {
        style: {
          pointerEvents: "none"
        }
      }),
      disableTooltip: this.state.disableTooltip,
      color: "primaryContrast",
      disabled: this.props.disabled
    }));
  }
}
export default SettingsHeaderItem;
SettingsHeaderItem.propTypes = {
  handleSettingsDrawer: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
SettingsHeaderItem.defaultProps = {
  disabled: false
};